export default __webpack_public_path__ + "static/media/logo_top.02554435.png";